// CUSTOM PRODUCT IMAGES SLIDER
document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll(".carousel");

  carousels.forEach((caroussel) => {
    const carousselInner = caroussel.querySelector(".carousel-inner");
    const carousselDots = caroussel.querySelector(".carousel-indicators");
    
    // Scoped strictly to this carousel instance
    const childElements = caroussel.querySelectorAll('.carousel-inner > .carousel-item');
    const items = childElements.length;
    let currentSlideElement = 0; 

    // Prevent errors if the carousel is empty or missing inner content
    if (!carousselInner) return;

    // Reset scroll initially
    carousselInner.scrollTo({
      left: 0,
      behavior: 'smooth'
    });

    caroussel.addEventListener("click", (e) => {
      // Find closest controls in case SVG/path is clicked inside the button
      const controlTarget = e.target.closest(".carousel-control") || e.target.closest(".carousel-bullet");
      
      if (controlTarget) {
        slideWithButton(controlTarget.dataset.control, caroussel, carousselInner, carousselDots, items, childElements);
      } else if (e.target.classList.contains("carousel-item__img") || e.target.closest(".zoom-button")) {
        zoomCaroussel(caroussel);
      }
    });

    carousselInner.addEventListener('touchend', () => {
      if (childElements.length === 0) return;

      let scrollLeft = carousselInner.scrollLeft;
      let parentWidth = carousselInner.clientWidth;
      let childOffsetLeft = childElements[currentSlideElement].offsetLeft;
      let childWidth = childElements[currentSlideElement].clientWidth;

      if (scrollLeft >= childOffsetLeft + (childWidth / 2) - parentWidth / 2) {
        if (currentSlideElement < childElements.length - 1) {
          const nextChild = childElements[currentSlideElement + 1];
          carousselInner.scrollTo({
            left: nextChild.offsetLeft,
            behavior: 'smooth'
          });
          currentSlideElement += 1;
        }
      } else if (scrollLeft <= childOffsetLeft + (childWidth / 2) - parentWidth / 5) {
        if (currentSlideElement > 0) {
          const nextChild = childElements[currentSlideElement - 1];
          carousselInner.scrollTo({
            left: nextChild.offsetLeft,
            behavior: 'smooth'
          });
          currentSlideElement -= 1;
        }
      }
    });
  });

  // --- Helper Functions ---

  function slideWithButton(controlStr, caroussel, carousselInner, carousselDots, items, childElements) {
    const control = parseInt(controlStr, 10);
    const carousselWidth = caroussel.offsetWidth;

    if (window.innerWidth >= 771) {
      carousselInner.style.transform = `translateX(-${carousselWidth * control}px)`;

      if (!carousselDots) return;

      if (control < 3) {
        carousselDots.style.transform = "translateX(0px)";
      } 
      else if (control >= (items - 3)) {
        // Use caroussel.querySelector instead of document.querySelector to stay scoped
        const child = caroussel.querySelector(`li:has(.carousel-bullet[data-control="${control}"])`);
        if (child) {
          const parent = child.parentElement;
          const moveToEnd = -1 * (parent.offsetWidth - carousselWidth);
          carousselDots.style.transform = `translateX(${moveToEnd}px)`;
        }
      } 
      else if (control >= 3) {
        const child = caroussel.querySelector(`li:has(.carousel-bullet[data-control="${control}"])`);
        if (child) {
          const parent = child.parentElement;
          const parentRect = parent.getBoundingClientRect();
          const childRect = child.getBoundingClientRect();
          const xDistance = childRect.left - parentRect.left;
          
          const parentWidth = carousselWidth;
          const childWidth = child.offsetWidth;
          const distanceToMove = ((parentWidth - childWidth) / 2) - xDistance;
          carousselDots.style.transform = `translateX(${distanceToMove.toFixed(2)}px)`;
        }
      }
    } else {
      const nextChild = childElements[control];
      if (nextChild) {
        carousselInner.scrollTo({
          left: nextChild.offsetLeft,
          behavior: 'smooth'
        });
      }
    }
  }

  function zoomCaroussel(caroussel) {
    const fragment = new DocumentFragment();
    const container = document.createElement("div");
    const closeButton = document.createElement("button");
    const clonedCarousel = caroussel.cloneNode(true);
    const carouselInner = clonedCarousel.querySelector(".carousel-inner");
    const dots = clonedCarousel.querySelector(".carousel-indicators");

    carouselInner.style.transform = "";
    clonedCarousel.classList.remove("carousel");
    clonedCarousel.classList.add("clone-carousel");
    container.classList.add("opeen");
    
    closeButton.innerHTML = '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="m7.5 22.5 15-15m-15 0 15 15"></path></svg>';
    closeButton.type = 'button';
    closeButton.classList.add("close-button");
    
    // Pass the clone to our dynamically updated function
    updateCarouselIds(clonedCarousel);
    if (dots) dots.remove();

    container.appendChild(closeButton);
    container.appendChild(clonedCarousel);
    fragment.appendChild(container);
    document.body.appendChild(fragment);
    
    closeButton.addEventListener("click", () => { container.remove(); });
  }

  function updateCarouselIds(clonedCarousel) {
    const inputs = clonedCarousel.querySelectorAll('input[type="radio"]');
    // Generate a uniquely random name for the clone so it never conflicts with the main page
    const uniqueSuffix = Date.now().toString(36); 
    const newName = `carousel-clone-${uniqueSuffix}`;

    inputs.forEach((input, index) => {
      const oldId = input.id;
      const newId = `${newName}-${index}`;
      
      input.id = newId;
      input.name = newName;

      // Find the specific labels pointing to this exact old input ID and update them
      const labels = clonedCarousel.querySelectorAll(`label[for="${oldId}"]`);
      labels.forEach((label) => {
        label.setAttribute('for', newId);
      });
    });

    const imgs = clonedCarousel.querySelectorAll('img');
    imgs.forEach((img) => {
      const oldSrcValue = img.getAttribute('src');
      if (oldSrcValue) {
        img.setAttribute("src", oldSrcValue.replaceAll("width=600", `width=${window.innerHeight}`));
      }
    });
  }
});

// CUSTOM ACCORDION
window.faqSec = true;
document.querySelectorAll(".accordion .details summary").forEach((element) =>
  element.addEventListener("click", (event) => {
    event.preventDefault();
    const detailsElement = event.target.parentElement;
    const contentElement = event.target.nextElementSibling;
    const contentInvisibleElement = contentElement.nextElementSibling;
    const contentInvisibleElementMobile = contentElement.nextElementSibling.nextElementSibling;
    let height = contentInvisibleElement.offsetHeight;
    let heightMobile = "";
    if (contentInvisibleElementMobile) {
      heightMobile = contentInvisibleElementMobile.offsetHeight;
    }

    detailsElement.classList.toggle("active");
    if (window.innerWidth > 770 || !contentInvisibleElementMobile) {
      if (detailsElement.classList.contains("active")) {
        contentElement.style.height = `${height}px`;
      } else {
        contentElement.style.height = "0px";
      }
    } else {
      if (detailsElement.classList.contains("active")) {
        contentElement.style.height = `${heightMobile}px`;
      } else {
        contentElement.style.height = "0px";
      }
    }
  })
);